import script from "./SpuDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SpuDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SpuDetailDrawer.vue?vue&type=style&index=0&id=443ef858&scoped=true&lang=scss"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-443ef858"]])

export default __exports__